// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══════════════════════════════════════════════════════
   Admin Layout — Clean MUI-like Sidebar + Light Content
   ═══════════════════════════════════════════════════════ */

:root {
  --sidebar-width: 240px;
  --sidebar-collapsed: 72px;
  --topbar-height: 56px;
  --color-sidebar-bg: #ffffff;
  --color-sidebar-hover: #F5F6FA;
  --color-sidebar-active: #EFF6FF;
  --color-text-sidebar: #6B7280;
  --color-text-sidebar-active: #2563EB;
  --color-surface: #ffffff;
  --color-page-bg: #F5F6FA;
  --color-border: #E4E7EE;
  --color-accent: #2563EB;
  --radius-lg: 12px;
  --radius-md: 8px;
  --shadow-card: 0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04);
  --shadow-elevated: 0 4px 16px rgba(0,0,0,0.08);
  --transition: 150ms ease;
}

/* ── Layout Grid ── */
.admin-layout {
  display: flex;
  min-height: 100vh;
  background: var(--color-page-bg);
}

/* ── Sidebar ── */
.admin-sidebar {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: var(--sidebar-width);
  background: var(--color-sidebar-bg);
  border-right: 1px solid var(--color-border);
  display: flex;
  flex-direction: column;
  z-index: 200;
  transition: width var(--transition);
  overflow: visible;
}

.sidebar-collapsed .admin-sidebar {
  width: var(--sidebar-collapsed);
}

.sidebar-overlay {
  display: none;
}

/* Brand */
.sidebar-brand {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 20px;
  border-bottom: 1px solid var(--color-border);
  height: var(--topbar-height);
  flex-shrink: 0;
}

.brand-icon {
  width: 30px;
  height: 30px;
  background-color: var(--surface);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
}

.brand-text {
  font-size: 0.875rem;
  font-weight: 600;
  color: #111827;
  white-space: nowrap;
}

/* Navigation */
.sidebar-nav {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  padding: 12px 0;
  gap: 4px;
  overflow-y: auto;
}

.nav-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 16px;
  margin: 0 12px;
  border-radius: 8px;
  color: var(--color-text-sidebar);
  text-decoration: none;
  font-size: 0.875rem;
  font-weight: 400;
  transition: all var(--transition);
  position: relative;
  white-space: nowrap;
}

.nav-item:hover {
  background: var(--color-sidebar-hover);
  color: #111827;
}

.nav-item.active {
  background: var(--color-sidebar-active);
  color: var(--color-text-sidebar-active);
  font-weight: 500;
}

.nav-item.active::before {
  content: "";
  position: absolute;
  left: -12px;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 20px;
  border-radius: 0 3px 3px 0;
  background-color: var(--color-accent);
}

.nav-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  color: inherit;
  flex-shrink: 0;
}

.nav-label {
  opacity: 1;
  transition: opacity var(--transition);
}

.sidebar-collapsed .nav-label {
  opacity: 0;
  width: 0;
  overflow: hidden;
}

/* Sidebar Footer */
.sidebar-footer {
  padding: 16px;
  border-top: 1px solid var(--color-border);
  display: flex;
  align-items: center;
  gap: 12px;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1;
  min-width: 0;
}

.user-avatar {
  width: 32px;
  height: 32px;
  background-color: var(--color-accent);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 0.75rem;
  color: #fff;
  flex-shrink: 0;
}

.user-details {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.user-name {
  font-size: 0.8125rem;
  font-weight: 500;
  color: #111827;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-role {
  font-size: 0.75rem;
  color: #6B7280;
}

.sidebar-collapsed .user-details {
  display: none;
}

.logout-btn {
  background: none;
  color: #6B7280;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color var(--transition);
  padding: 4px;
}

.logout-btn:hover {
  color: #111827;
}

.collapse-btn {
  position: absolute;
  top: 50%;
  right: -12px;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  background: #ffffff;
  border: 1px solid var(--color-border);
  border-radius: 50%;
  color: #6B7280;
  font-size: 0.65rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all var(--transition);
  z-index: 201;
  box-shadow: 0 1px 3px rgba(0,0,0,0.06);
}

.collapse-btn:hover {
  background: #F5F6FA;
  color: #111827;
}

/* ── Main Content Area ── */
.admin-main {
  margin-left: var(--sidebar-width);
  flex: 1 1;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  transition: margin-left var(--transition);
}

.sidebar-collapsed .admin-main {
  margin-left: var(--sidebar-collapsed);
}

/* Topbar */
.admin-topbar {
  position: sticky;
  top: 0;
  z-index: 100;
  height: var(--topbar-height);
  background: #ffffff;
  border-bottom: 1px solid var(--color-border);
  display: flex;
  align-items: center;
  padding: 0 24px;
  gap: 16px;
  flex-shrink: 0;
}

.mobile-menu-btn {
  display: none;
  background: none;
  border: none;
  padding: 4px;
  cursor: pointer;
  color: #6B7280;
}

.page-title {
  font-size: 1.125rem;
  font-weight: 600;
  color: #111827;
  flex: 1 1;
}

.topbar-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.topbar-role-badge {
  display: inline-block;
  padding: 2px 8px;
  background: #EFF6FF;
  border: 1px solid #BFDBFE;
  color: #2563EB;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 500;
}

/* Content */
.admin-content {
  padding: 24px;
  flex: 1 1;
}

/* ── Responsive ── */
@media (max-width: 1024px) {
  .admin-sidebar {
    transform: translateX(-100%);
    width: var(--sidebar-width) !important;
    box-shadow: var(--shadow-elevated);
  }

  .admin-sidebar.open {
    transform: translateX(0);
  }

  .sidebar-overlay {
    display: block;
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.4);
    z-index: 199;
  }

  .admin-main {
    margin-left: 0 !important;
  }

  .mobile-menu-btn {
    display: flex;
  }

  .collapse-btn {
    display: none;
  }

  .admin-content {
    padding: 16px;
  }

  .admin-topbar {
    padding: 0 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/AdminLayout.css"],"names":[],"mappings":"AAAA;;4DAE4D;;AAE5D;EACE,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,2BAA2B;EAC3B,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;EAC7B,oCAAoC;EACpC,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,qEAAqE;EACrE,8CAA8C;EAC9C,wBAAwB;AAC1B;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,SAAS;EACT,2BAA2B;EAC3B,mCAAmC;EACnC,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;AACf;;AAEA,UAAU;AACV;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,4CAA4C;EAC5C,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gCAAgC;EAChC,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,YAAY;EACZ,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,qCAAqC;AACvC;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;EACP,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iCAAiC;EACjC,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,iCAAiC;EACjC,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,qCAAqC;AACvC;;AAEA,WAAW;AACX;EACE,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,4BAA4B;EAC5B,mBAAmB;EACnB,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,SAAO;AACT;;AAEA,qBAAqB;AACrB;EACE;IACE,4BAA4B;IAC5B,sCAAsC;IACtC,kCAAkC;EACpC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;IACd,eAAe;IACf,QAAQ;IACR,2BAA2B;IAC3B,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* ═══════════════════════════════════════════════════════\r\n   Admin Layout — Clean MUI-like Sidebar + Light Content\r\n   ═══════════════════════════════════════════════════════ */\r\n\r\n:root {\r\n  --sidebar-width: 240px;\r\n  --sidebar-collapsed: 72px;\r\n  --topbar-height: 56px;\r\n  --color-sidebar-bg: #ffffff;\r\n  --color-sidebar-hover: #F5F6FA;\r\n  --color-sidebar-active: #EFF6FF;\r\n  --color-text-sidebar: #6B7280;\r\n  --color-text-sidebar-active: #2563EB;\r\n  --color-surface: #ffffff;\r\n  --color-page-bg: #F5F6FA;\r\n  --color-border: #E4E7EE;\r\n  --color-accent: #2563EB;\r\n  --radius-lg: 12px;\r\n  --radius-md: 8px;\r\n  --shadow-card: 0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04);\r\n  --shadow-elevated: 0 4px 16px rgba(0,0,0,0.08);\r\n  --transition: 150ms ease;\r\n}\r\n\r\n/* ── Layout Grid ── */\r\n.admin-layout {\r\n  display: flex;\r\n  min-height: 100vh;\r\n  background: var(--color-page-bg);\r\n}\r\n\r\n/* ── Sidebar ── */\r\n.admin-sidebar {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  bottom: 0;\r\n  width: var(--sidebar-width);\r\n  background: var(--color-sidebar-bg);\r\n  border-right: 1px solid var(--color-border);\r\n  display: flex;\r\n  flex-direction: column;\r\n  z-index: 200;\r\n  transition: width var(--transition);\r\n  overflow: visible;\r\n}\r\n\r\n.sidebar-collapsed .admin-sidebar {\r\n  width: var(--sidebar-collapsed);\r\n}\r\n\r\n.sidebar-overlay {\r\n  display: none;\r\n}\r\n\r\n/* Brand */\r\n.sidebar-brand {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  padding: 0 20px;\r\n  border-bottom: 1px solid var(--color-border);\r\n  height: var(--topbar-height);\r\n  flex-shrink: 0;\r\n}\r\n\r\n.brand-icon {\r\n  width: 30px;\r\n  height: 30px;\r\n  background-color: var(--surface);\r\n  border-radius: 8px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-shrink: 0;\r\n  overflow: hidden;\r\n}\r\n\r\n.brand-text {\r\n  font-size: 0.875rem;\r\n  font-weight: 600;\r\n  color: #111827;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* Navigation */\r\n.sidebar-nav {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 12px 0;\r\n  gap: 4px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.nav-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  padding: 10px 16px;\r\n  margin: 0 12px;\r\n  border-radius: 8px;\r\n  color: var(--color-text-sidebar);\r\n  text-decoration: none;\r\n  font-size: 0.875rem;\r\n  font-weight: 400;\r\n  transition: all var(--transition);\r\n  position: relative;\r\n  white-space: nowrap;\r\n}\r\n\r\n.nav-item:hover {\r\n  background: var(--color-sidebar-hover);\r\n  color: #111827;\r\n}\r\n\r\n.nav-item.active {\r\n  background: var(--color-sidebar-active);\r\n  color: var(--color-text-sidebar-active);\r\n  font-weight: 500;\r\n}\r\n\r\n.nav-item.active::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  left: -12px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  width: 3px;\r\n  height: 20px;\r\n  border-radius: 0 3px 3px 0;\r\n  background-color: var(--color-accent);\r\n}\r\n\r\n.nav-icon {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: inherit;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.nav-label {\r\n  opacity: 1;\r\n  transition: opacity var(--transition);\r\n}\r\n\r\n.sidebar-collapsed .nav-label {\r\n  opacity: 0;\r\n  width: 0;\r\n  overflow: hidden;\r\n}\r\n\r\n/* Sidebar Footer */\r\n.sidebar-footer {\r\n  padding: 16px;\r\n  border-top: 1px solid var(--color-border);\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n}\r\n\r\n.user-info {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.user-avatar {\r\n  width: 32px;\r\n  height: 32px;\r\n  background-color: var(--color-accent);\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-weight: 600;\r\n  font-size: 0.75rem;\r\n  color: #fff;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.user-details {\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n}\r\n\r\n.user-name {\r\n  font-size: 0.8125rem;\r\n  font-weight: 500;\r\n  color: #111827;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.user-role {\r\n  font-size: 0.75rem;\r\n  color: #6B7280;\r\n}\r\n\r\n.sidebar-collapsed .user-details {\r\n  display: none;\r\n}\r\n\r\n.logout-btn {\r\n  background: none;\r\n  color: #6B7280;\r\n  border: none;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: color var(--transition);\r\n  padding: 4px;\r\n}\r\n\r\n.logout-btn:hover {\r\n  color: #111827;\r\n}\r\n\r\n.collapse-btn {\r\n  position: absolute;\r\n  top: 50%;\r\n  right: -12px;\r\n  transform: translateY(-50%);\r\n  width: 24px;\r\n  height: 24px;\r\n  background: #ffffff;\r\n  border: 1px solid var(--color-border);\r\n  border-radius: 50%;\r\n  color: #6B7280;\r\n  font-size: 0.65rem;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n  transition: all var(--transition);\r\n  z-index: 201;\r\n  box-shadow: 0 1px 3px rgba(0,0,0,0.06);\r\n}\r\n\r\n.collapse-btn:hover {\r\n  background: #F5F6FA;\r\n  color: #111827;\r\n}\r\n\r\n/* ── Main Content Area ── */\r\n.admin-main {\r\n  margin-left: var(--sidebar-width);\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 100vh;\r\n  transition: margin-left var(--transition);\r\n}\r\n\r\n.sidebar-collapsed .admin-main {\r\n  margin-left: var(--sidebar-collapsed);\r\n}\r\n\r\n/* Topbar */\r\n.admin-topbar {\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 100;\r\n  height: var(--topbar-height);\r\n  background: #ffffff;\r\n  border-bottom: 1px solid var(--color-border);\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 0 24px;\r\n  gap: 16px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.mobile-menu-btn {\r\n  display: none;\r\n  background: none;\r\n  border: none;\r\n  padding: 4px;\r\n  cursor: pointer;\r\n  color: #6B7280;\r\n}\r\n\r\n.page-title {\r\n  font-size: 1.125rem;\r\n  font-weight: 600;\r\n  color: #111827;\r\n  flex: 1;\r\n}\r\n\r\n.topbar-right {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n}\r\n\r\n.topbar-role-badge {\r\n  display: inline-block;\r\n  padding: 2px 8px;\r\n  background: #EFF6FF;\r\n  border: 1px solid #BFDBFE;\r\n  color: #2563EB;\r\n  border-radius: 999px;\r\n  font-size: 0.75rem;\r\n  font-weight: 500;\r\n}\r\n\r\n/* Content */\r\n.admin-content {\r\n  padding: 24px;\r\n  flex: 1;\r\n}\r\n\r\n/* ── Responsive ── */\r\n@media (max-width: 1024px) {\r\n  .admin-sidebar {\r\n    transform: translateX(-100%);\r\n    width: var(--sidebar-width) !important;\r\n    box-shadow: var(--shadow-elevated);\r\n  }\r\n\r\n  .admin-sidebar.open {\r\n    transform: translateX(0);\r\n  }\r\n\r\n  .sidebar-overlay {\r\n    display: block;\r\n    position: fixed;\r\n    inset: 0;\r\n    background: rgba(0,0,0,0.4);\r\n    z-index: 199;\r\n  }\r\n\r\n  .admin-main {\r\n    margin-left: 0 !important;\r\n  }\r\n\r\n  .mobile-menu-btn {\r\n    display: flex;\r\n  }\r\n\r\n  .collapse-btn {\r\n    display: none;\r\n  }\r\n\r\n  .admin-content {\r\n    padding: 16px;\r\n  }\r\n\r\n  .admin-topbar {\r\n    padding: 0 16px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
